import { genericJourneyResolverMapping } from '@dxb-web-ui-framework/mocks/msw/types';
import { genericMapToHandlers } from '@dxb-web-ui-framework/mocks/msw/utils/genericMapToHandlers';
import { ecommbx } from '../../index';

const payrollMap: genericJourneyResolverMapping[] = [
  {
    url: /\/api\/private\/bulk\/payroll\/file\/process\/\d+\/[a-z0-9-]+/,
    response: () => ecommbx.payrollProcessAuthorizationData,
    method: 'put',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/bulk\/payroll\/\d+\/file/,
    response: () => ecommbx.payrollUploadFileData,
    method: 'post',
    responseHeaders: { code: '201' },
  },
  {
    url: /\/api\/private\/bulk\/payroll\/list\/\d+/,
    response: () => ecommbx.payrollListData,
    method: 'get',
    responseHeaders: { code: '201' },
  },
  {
    url: /\/api\/private\/bulk\/payroll\/file\/\d+\/\d+\/initiate/,
    response: () => ecommbx.payrollCreateProcessingAuthorizationData,
    method: 'post',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/bulk\/payroll\/\d+\/total/,
    response: () => ecommbx.payrollTotalData,
    method: 'get',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/bulk\/payroll\/details\/\d+\/\d+/,
    response: () => ecommbx.payrollDetailsData,
    method: 'get',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/bulk\/payroll\/fileTypes/,
    response: () => ecommbx.payrollFileTypes,
    method: 'get',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/bulk\/payroll\/\d+/,
    response: () => ecommbx.payrollDeleteData,
    method: 'delete',
    responseHeaders: { code: '200' },
  },
];

const payrollHandlers = payrollMap.map(genericMapToHandlers);

export { payrollHandlers };
